import { render, staticRenderFns } from "./WorkoutVideo.vue?vue&type=template&id=562af637&scoped=true&"
import script from "./WorkoutVideo.vue?vue&type=script&lang=js&"
export * from "./WorkoutVideo.vue?vue&type=script&lang=js&"
import style0 from "./WorkoutVideo.vue?vue&type=style&index=0&id=562af637&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "562af637",
  null
  
)

export default component.exports